import { render, staticRenderFns } from "./StopN_Items.vue?vue&type=template&id=2282fece"
import script from "./StopN_Items.vue?vue&type=script&lang=js"
export * from "./StopN_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports